<template>
	<AppCard :title="title">
		<slot />
	</AppCard>
</template>

<script setup lang="ts">
defineProps<{ title: string }>();
</script>
